import axios from 'axios';
import log from 'loglevel';
import {
  CreateAdCampaignDto,
  EAdCreativeMediaType,
  IAdCreativeAsset,
  UpdateAdCampaignDto,
} from 'types/ad-campaign';

import { apiClient } from '.';

export type UploadProgressCallback = (progress: number) => void;

export const uploadAdCreative = async (
  file: File,
  mediaType: EAdCreativeMediaType,
  onProgress?: UploadProgressCallback,
) => {
  const createUploadResponse = await apiClient.post('/digital-ads/creative-assets/uploads', {
    filename: file.name,
    mimeType: file.type,
    byteSize: file.size,
    mediaType,
  });
  const { asset, upload } = createUploadResponse.data.data;

  await axios.put(upload.url, file, {
    headers: upload.headers,
    onUploadProgress: (progressEvent) => {
      if (!onProgress || !progressEvent.total) return;
      onProgress(Math.round((progressEvent.loaded / progressEvent.total) * 100));
    },
  });

  const completeResponse = await apiClient.post(`/digital-ads/creative-assets/${asset._id}/complete`);
  return completeResponse.data.data as IAdCreativeAsset;
};

/**
 * @returns The new ad campaign id
 */
export const createAdCampaign = async (createAdCampaignDto: CreateAdCampaignDto): Promise<string> => {
  const response = await apiClient.post('/digital-ads/create', createAdCampaignDto);

  log.debug('called createAdCampaign and got', response.data);

  return response.data.adCampaignId;
};

export const updateAdCampaign = async (adCampaignId: string, updateAdCampaignDto: UpdateAdCampaignDto) => {
  const response = await apiClient.patch(`/digital-ads/${adCampaignId}`, updateAdCampaignDto);

  log.debug('called updateAdCampaign and got', response.data);

  return response.data;
};
